import React from "react"
import { Container } from "@mui/material"

const BackgroundWrapper = ({
  backgroundColor,
  topGutterSpacing,
  bottomGutterSpacing,
  children,
  style
}) => {
  return (
    <Container
      sx={{
        backgroundColor: backgroundColor
          ? backgroundColor
          : `background.default`,
        paddingTop: topGutterSpacing || 0,
        paddingBottom: bottomGutterSpacing || 0,
        ...style
      }}
      disableGutters
      maxWidth={false}
      className="backgroundWrapper"
    >
      {children}
    </Container>
  )
}

export default BackgroundWrapper
